module.exports = __webpack_public_path__ + "components/country-flag/static/ss-5ca5e635ac89c328a938e89e4fb16911.svg";